<template>
    <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" class="login-form">
        <el-form-item prop="account" class="mb-16">
            <el-input size="large" v-model="loginForm.account" placeholder="请输入手机号" maxlength="20" name="phone" autofocus>
                <template #prefix><i class="iconfont icon-Frame-21"></i></template>
            </el-input>
        </el-form-item>
        <el-form-item prop="password">
            <el-input
                type="password"
                name="password"
                show-password
                size="large"
                v-model="loginForm.password"
                placeholder="请输入登录密码"
                maxlength="20"
                @keyup.enter="clickLoginBtn"
            >
                <template #prefix><i class="iconfont icon-Frame-12"></i></template>
            </el-input>
        </el-form-item>
    </el-form>
    <el-button class="submit-btn" type="primary" @click="clickLoginBtn" :loading="loading" :disabled="isSubmitDisabled"
        >登录</el-button
    >
</template>

<script lang="ts" setup>
import { computed, reactive, ref } from "vue";
import { ElForm, ElInput, ElFormItem, ElButton, FormInstance } from "element-plus";
import { loginService } from "@/api/services/loginService";
import { phoneReg } from "@/utils/validate";
import { useUserStore } from "@/stores/modules/user";
import { customerLoginService } from "@/api/services/customerLoginService";
import { isApiError, SYSTEM_LOGIN_TYPE } from "../type.ts";
const props = defineProps<{ deviceCode: string; systemType: number; isChecked: boolean }>();
const emits = defineEmits(["getToken", "verifyIdentity", "isSelectAgreements"]);
const loginForm = reactive({ account: "", password: "", deviceCode: "" });
const loginRules = {
    account: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        { pattern: phoneReg, message: "请输入正确的手机号", trigger: "blur" }
    ],
    password: [{ required: true, message: "请输入登录密码", trigger: "blur" }]
};
const loginFormRef = ref<FormInstance>();
const userStore = useUserStore();
const loading = ref<boolean>(false);
const isSubmitDisabled = computed(() => {
    return !(loginForm.account && loginForm.password);
});
/** 点击登录 */
const clickLoginBtn = () => {
    loginFormRef.value!.validate(async valid => {
        //是否勾选协议
        if (!props.isChecked) {
            emits("isSelectAgreements");
            return;
        }
        if (valid) {
            try {
                loading.value = true;
                loginForm.deviceCode = props.deviceCode;
                if (props.systemType === SYSTEM_LOGIN_TYPE.ADMIN) {
                    await adminAccountLogin();
                } else if (props.systemType === SYSTEM_LOGIN_TYPE.CUSTOMER) {
                    await customerAccountLogin();
                }
                loading.value = false;
            } catch (err) {
                loading.value = false;
                // 新设备登录需要校验验证码
                if (isApiError(err) && err.response?.data?.code === "30011002") {
                    emits("verifyIdentity", loginForm.account);
                }
            }
        }
    });
};
const adminAccountLogin = async () => {
    const data = await loginService.account(loginForm);
    emits("getToken", data.accessToken);
    userStore.setMobile(loginForm.account);
};
// 客户端-账号登录
const customerAccountLogin = async () => {
    const data = await customerLoginService.accountLogin(loginForm);
    emits("getToken", data.accessToken);
    userStore.setMobile(loginForm.account);
};
</script>

<style lang="scss" scoped>
.login-btn {
    width: 100%;
}

.login-client {
    position: relative;
    top: -12px;
    color: #2143fc;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    text-transform: capitalize;
}

.click-jump {
    position: relative;
    text-align: center;
    cursor: pointer;
    top: -15px;
    left: 105px;
    color: #2143fc;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    text-transform: capitalize;
}
.submit-btn {
    height: 40px;
    width: 100%;
    color: var(--el-color-button-text-color);
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    padding: 17px 0;
    border-radius: 6px;
    margin-top: 12px;
    :deep(span) {
        color: #ffffff;
    }
}
</style>
